import React from "react";
import Layout from "../../Components/Dashboard/Layout/Layout";
import ManageServiceSection1 from "../../Components/Dashboard/ManageService/ManageServiceSection1";

const ManageService = () => {
  return (
    <>
      <Layout>
        <div
          className="dashboard__content hover-bgc-color"
          style={{ marginTop: "6%" }}
        >
          <ManageServiceSection1 />
        </div>
      </Layout>
    </>
  );
};

export default ManageService;
